import { render } from "./App.vue?vue&type=template&id=5f8ef79c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5f8ef79c&lang=css"

import exportComponent from "/Users/francoishameau/code/efache/iad/iad-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__